import React, { useState } from 'react'
import { Card, CardBody, Button, Modal, Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap'
import Success from 'pages/NotificationModal/Success'
import ErrorModal from 'pages/NotificationModal/Error'

const API_URL = process.env.REACT_APP_API_URL

const ReopenManualReview = () => {
    const [apptId, setApptId] = useState('')
    const [touched, setTouched] = useState(false)
    const [loading, setLoading] = useState(false)
    const [showSuccess, setShowSuccess] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const handleSubmit = async (e) => {
        e.preventDefault()
        setTouched(true)
        if (!apptId) return

        setLoading(true)
        try {
            const url = `${API_URL}crs/manual-reviews?appt_id=${encodeURIComponent(apptId)}`
            const response = await fetch(url, { method: 'PUT', credentials: 'include' })
            if (!response.ok) {
                let msg = 'Failed to reopen manual review.'
                try { const data = await response.json(); msg = data.message || msg } catch (_) {}
                throw new Error(msg)
            }
            setShowSuccess(true)
        } catch (err) {
            setErrorMessage(err.message || 'Failed to reopen manual review.')
            setShowError(true)
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <Modal isOpen={showSuccess} toggle={() => setShowSuccess(false)} centered size="sm">
                <Success
                    message="Manual review reopened successfully!"
                    close={() => {
                        setShowSuccess(false)
                        setApptId('')
                        setTouched(false)
                    }}
                />
            </Modal>

            <Modal isOpen={showError} toggle={() => setShowError(false)} centered size="sm">
                <ErrorModal
                    message={errorMessage}
                    closeModal={() => setShowError(false)}
                />
            </Modal>

            <Card className="p-3">
                <CardBody>
                    <Form onSubmit={handleSubmit}>
                        <FormGroup>
                            <Label for="apptId" style={{ fontWeight: '600', fontSize: '13px' }}>
                                Appointment ID
                            </Label>
                            <Input
                                id="apptId"
                                type="text"
                                value={apptId}
                                onChange={(e) => setApptId(e.target.value)}
                                onBlur={() => setTouched(true)}
                                placeholder="Appointment ID associated with a manual review"
                                invalid={touched && !apptId}
                                style={{ fontSize: '13px' }}
                            />
                            <FormFeedback>Appointment ID is required.</FormFeedback>
                        </FormGroup>
                        <div className="modal-footer px-0 pb-0">
                            <Button
                                type="submit"
                                color="warning"
                                size="sm"
                                disabled={loading || !apptId}
                            >
                                {loading ? 'Submitting...' : 'Reopen'}
                            </Button>
                        </div>
                    </Form>
                </CardBody>
            </Card>
        </>
    )
}

export default ReopenManualReview
